module.exports = __webpack_public_path__ + "img/pencilIcon.43e6dfb1.svg";